import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { AWARDS_QUERY } from '../graphql/queries'
import { FETCH_AWARDS } from '../redux/action-types'
import { cleanupFetchAwards } from '../redux/actions'

const useAwardsQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchAwards)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.awards.awards,
  )

  const refetch = useCallback(
    () => apolloService.query(AWARDS_QUERY, {}, dispatch, FETCH_AWARDS),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useAwardsQuery
